import { del, get, post } from "@/utils/httpRequest";

const prefix = process.env.VUE_APP_API_URL + "/version/view";

const listPageUri = prefix + "/page";
const addUri = prefix + "/create";
const editUri = prefix + "/edit";
const delUri = prefix + "/del";
const getOneUri = prefix + "/oneById";

//分页列表
const getPage = params => get(listPageUri, params, { showLoading: false });

//新增或者编辑
const addOrUpdate = function(data) {
  let uri = !data.id ? addUri : editUri;
  return post(uri, data, { showLoading: false });
};

//逻辑删除版本
const delVersion = id => {
  return del(delUri, { id: id });
};

//获取指定版本
const getOneById = id => get(getOneUri, { id: id });

export default {
  addOrUpdate,
  getOneById,
  getPage,
  delVersion
};
